import React, { Component } from 'react';
import {
    Panel,
    Col,
    Row,
    FormGroup,
    ControlLabel,
    FormControl,
    HelpBlock,
    Button
} from 'react-bootstrap';
import axios from 'axios';
import { Link } from 'react-router-dom';
import logo from '../logo.png';
import cyberlogo from '../cyber.jpg';
import config from '../config';
import DismissableAlert from '../components/DismissableAlert';

class TwoFactorResetVerify extends Component {
    state = {
        questions: [],
        answers: {},
        token: '',
        isLoading: false,
        verified: false,
        error: {
            hidden: true,
            title: '',
            message: '',
            style: 'danger'
        }
    };

    componentDidMount() {
        const params = new URLSearchParams(this.props.location.search);
        const token = params.get('token');

        if (!token) {
            this.setState({
                error: {
                    hidden: false,
                    title: 'Error:',
                    message: 'Missing token.',
                    style: 'danger'
                }
            });
            return;
        }

        this.setState({ token });

        axios
            .get(`${config.baseURL}/auth/reset-2fa/questions?token=${token}`)
            .then((res) => {
                
                this.setState({ questions: res.data.questions });
            })
            .catch(() => {
                this.setState({
                    error: {
                        hidden: false,
                        title: 'Error:',
                        message: 'Invalid or expired reset token.',
                        style: 'danger'
                    }
                });
            });
    }

    handleChange = (question_id, value) => {
        this.setState((prev) => ({
            answers: {
                ...prev.answers,
                [question_id]: value
            }
        }));
    };

    handleSubmit = () => {
        this.setState({ isLoading: true, error: {
            hidden: true,
            title: '',
            message: '',
            style: 'danger'
        } });

        const { token, answers } = this.state;

        axios
            .post(`${config.baseURL}/auth/reset-2fa/verify`, {
                token,
                answers: Object.entries(answers).map(([question_id, answer]) => ({
                    question_id: parseInt(question_id),
                    answer
                }))
            })
            .then(() => {
                this.setState({ verified: true, isLoading: false });
            })
            .catch(() => {
                this.setState({
                    isLoading: false,
                    error: {
                        hidden: false,
                        title: 'Error:',
                        message: 'Verification failed. Please try again.',
                        style: 'danger'
                    }
                });
            });
    };

    render() {
        const { questions, error, verified } = this.state;

        return (
            <div className="Login">
                <Row>
                    <Col
                        xs={10}
                        sm={6}
                        md={6}
                        lg={4}
                        xsOffset={1}
                        smOffset={3}
                        mdOffset={3}
                        lgOffset={4}
                    >
                        <Panel>
                            <Panel.Body>
                                
                                <a href="https://mysign.uk.com">
                                    <img
                                        src={logo}
                                        alt="logo"
                                        className="center-block img-responsive"
                                        style={{ width: 400, height: 123 }}
                                    />
                                </a>

                                <h4>Verify Your Identity</h4>
                                <p>Please answer your security questions to continue.</p>

                                 <DismissableAlert
                                    title={this.state.error.title}
                                    message={this.state.error.message}
                                    hidden={this.state.error.hidden}
                                    style={this.state.error.style}
                                />

                        
                                {verified ? (
                                    <HelpBlock className="text-success">
                                        Verified! You may now <Link to="/login">log in</Link> again.
                                    </HelpBlock>
                                ) : (
                                    <>
                                        {questions.map((q) => (
                                            <FormGroup key={q.id}>
                                                <ControlLabel>{q.question}</ControlLabel>
                                                <FormControl
                                                    type="text"
                                                    onChange={(e) =>
                                                        this.handleChange(q.question_id, e.target.value)
                                                    }
                                                />
                                            </FormGroup>
                                        ))}

                                        {questions.length > 0 && (
                                            <Button
                                                bsStyle="primary"
                                                block
                                                disabled={this.state.isLoading}
                                                onClick={this.handleSubmit}
                                            >
                                                {this.state.isLoading ? 'Verifying...' : 'Verify'}
                                            </Button>
                                        )}
                                    </>
                                )}
                            </Panel.Body>
                        </Panel>

                        <small style={{ display: 'flex', justifyContent: 'center' }}>
                            <Link to="/login">Back to Login</Link>
                        </small>

                        <img
                            src={cyberlogo}
                            alt="cyber logo"
                            className="center-block img-responsive"
                            style={{ width: 400, height: 100 }}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default TwoFactorResetVerify;
